import { AddPageFullFormValues } from '@insta-club/validator';

/**
 * Returns the form fields that need to be validated for each step
 */
const StepFields = (step: number): (keyof AddPageFullFormValues)[] => {
    const stepFieldsMap: Record<number, (keyof AddPageFullFormValues)[]> = {
        1: ['page'],
        2: ['field_id', 'category_id', 'is_store', 'store_type'],
        3: ['page_category'],
        4: ['start_after_days', 'best_post_time'],
        5: ['video_style_id']
    };

    return stepFieldsMap[step] || [];
};

export default StepFields;
